
import { useState } from 'react';
import { Button } from '@/components/ui/button';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';
import { Switch } from '@/components/ui/switch';
import { toggleAuthServiceLayer } from '@/hooks/useAuthWithFeatureFlag';
import { useAuth } from '@/context/AuthContext';

/**
 * Debug component for testing auth migration
 * Only for development/testing purposes
 */
export const AuthMigrationDebug = () => {
  const [useAuthServiceLayer, setUseAuthServiceLayer] = useState(
    localStorage.getItem('use_auth_service_layer') === 'true'
  );
  
  const auth = useAuth();

  const handleToggle = (enabled: boolean) => {
    setUseAuthServiceLayer(enabled);
    toggleAuthServiceLayer(enabled);
  };

  return (
    <Card className="max-w-md">
      <CardHeader>
        <CardTitle className="flex items-center gap-2">
          🔧 Auth Migration Debug
          <Badge variant={useAuthServiceLayer ? "default" : "secondary"}>
            {useAuthServiceLayer ? "V2" : "V1"}
          </Badge>
        </CardTitle>
        <CardDescription>
          Ferramenta de debug para testar a migração do AuthContext
        </CardDescription>
      </CardHeader>
      <CardContent className="space-y-4">
        <div className="flex items-center justify-between">
          <label htmlFor="auth-service-toggle" className="text-sm">
            Use Auth Service Layer (V2)
          </label>
          <Switch
            id="auth-service-toggle"
            checked={useAuthServiceLayer}
            onCheckedChange={handleToggle}
          />
        </div>
        
        <div className="p-3 bg-gray-50 rounded text-sm">
          <p><strong>Status:</strong> {auth.isAuthenticated ? 'Autenticado' : 'Não autenticado'}</p>
          <p><strong>Loading:</strong> {auth.loading ? 'Sim' : 'Não'}</p>
          <p><strong>User ID:</strong> {auth.user?.id || 'N/A'}</p>
          <p><strong>Implementation:</strong> {useAuthServiceLayer ? 'AuthContextV2' : 'AuthContext'}</p>
        </div>
        
        <div className="text-xs text-gray-500">
          ⚠️ Alternar entre versões recarregará a página
        </div>
      </CardContent>
    </Card>
  );
};
